import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Head from 'next/head';
import getEntityField from '~/src/lib/getEntityField';
import { useRouter, withRouter } from 'next/router';
import handleAuth from '~/src/lib/handleAuth';
import dynamic from 'next/dynamic';
import { useDispatch } from 'react-redux';
import actionsApp from '~/redux/app/actions';
import actionsCommon from '~/redux/common/actions';
import Cookies from 'js-cookie';
import Text from '~/src/components/Typography/Text';
import Image from 'next/image';
import CustomButtonOutlined from '~/src/components/CustomButtonOutlined';
import translateMsg from '~/src/lib/translateMsg';
import HrefLang from '~/src/components/HrefLang';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import { DateTime } from 'luxon';
import { COOKIE1, COOKIE2 } from '~/src//config/constants';
import { scroller } from 'react-scroll';
import isDisplayMenu from '~/src/lib/isDisplayMenu';

const Menu = dynamic(() => import('~/src/containers/Menu'), {
    ssr: false,
    loading: () => <p>...</p>,
});

function App(props) {
    const business = useSelector((state) => state.business);
    const languagesLoaded = useSelector(
        (state) => state.common.languagesLoaded,
    );
    const lang = useSelector((state) => state.lang);
    const user = useSelector((state) => state.user);

    const [ready, setReady] = useState(false);

    const dispatch = useDispatch();

    const router = useRouter();
    const { slug } = router.query;

    useEffect(() => {
        handleAuth();
        setReady(true);
        //window.scrollTo(0, 0);

        document.querySelector('body').setAttribute('id', 'menu');

        if (
            typeof document.location.hash === 'string' &&
            document.location.hash.length > 2
        ) {
            setTimeout(() => {
                scroller.scrollTo(document.location.hash.replace('#', ''), {
                    duration: 400,
                    delay: 10,
                    smooth: true,
                    offset: -140,
                });
            }, 200);
        }
    }, []);

    if (!business) {
        // return false;
    }
    if (Object.keys(business).length === 0) {
        return false;
    }

    if (ready === false) {
        return false;
    }

    if (languagesLoaded === false) {
        return false;
    }

    let match = false;

    match = business.menusV2.find((o) => o.slug === slug);
    //console.log(654);
    //console.log(match);
    //console.log(business.menusV2);

    if (match) {
        if (isDisplayMenu(match, user, lang) === false) {
            return false;
        }

        if (typeof match.start === 'string' && typeof match.end === 'string') {
            const now = DateTime.now();
            const start = DateTime.fromSQL(match.start);
            const end = DateTime.fromSQL(match.end);
            if (now > start && now < end) {
            } else {
                match = false;
            }
        }
    }

    if (match) {
        dispatch(actionsCommon.setSelectedMenu(match.id));

        if (match.typeMenu === 'inside') {
            dispatch(actionsCommon.setMenuType('inside'));
        } else if (match.typeMenu === 'takeaway') {
            dispatch(actionsCommon.setMenuType('takeaway'));
        } else if (match.typeMenu === 'delivery') {
            dispatch(actionsCommon.setMenuType('delivery'));
        }

        if (match.typeMenu !== 'inside') {
            //  on supprime les cookies de table

            const qrcode1 = Cookies.get(COOKIE1);
            if (typeof qrcode1 === 'string') {
                Cookies.remove(COOKIE1);
            }

            const qrcode2 = Cookies.get(COOKIE2);
            if (typeof qrcode2 === 'string') {
                Cookies.remove(COOKIE2);
            }
        }
    } else {
        return (
            <div
                style={{
                    textAlign: 'center',
                    margin: '25px auto',
                    maxWidth: 500,
                    padding: 20,
                }}
            >
                <div
                    style={{
                        marginTop: 30,
                        marginBottom: 30,
                    }}
                >
                    <Image
                        unoptimized
                        src="/img/searchNone.svg"
                        height={100}
                        width={100}
                    />
                </div>
                <div>
                    <Text variant="h4">
                        {translateMsg('webapp', 'pwa_ui__unavailable_title')}
                    </Text>
                </div>
                <div
                    style={{
                        marginTop: 20,
                        marginBottom: 40,
                    }}
                >
                    <Text variant="body1">
                        {translateMsg('webapp', 'pwa_ui__unavailable_content')}
                    </Text>
                </div>

                <div>
                    <CustomButtonOutlined
                        onClick={(event) => {
                            event.preventDefault();
                            router.push('/', '/');
                        }}
                        business={business}
                        fullWidth={false}
                        variant="contained"
                    >
                        {translateMsg('webapp', 'pwa_ui__home')}
                    </CustomButtonOutlined>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Head>
                <title>{business.info.name}</title>
                <meta
                    name="description"
                    content={getEntityField(business.info, 'information')}
                />
                {typeof business.info.catalog_indexable === 'number' &&
                    business.info.catalog_indexable === 0 && (
                        <meta name="robots" content="noindex, nofollow" />
                    )}
            </Head>
            <HrefLang />

            <Menu slug={slug} />
        </React.Fragment>
    );
}

export default App;
